import Vue from "vue";
import Router from "vue-router";
import store from "~/store/store";
import DefaultLayout from "./layouts/Default.vue";
import Visu from "./layouts/Visu.vue";
import mobileDrinksLayout from "./layouts/mobileDrinksLayout.vue";
import mobileDrinksList from "./pages/mobileDrinksList.vue";
import mobileDrinksDetail from "./pages/mobileDrinksDetail.vue";
import Welcome from "./layouts/Welcome.vue";
import Seance from "./views/Seance.vue";
import LiveSeance from "./views/LiveSeance.vue";
import { setJWT } from "~/services/api";

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/app",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import('~/views/Home.vue'),
          meta : {
            requiresAuth: true,
          }
        },
        {
          path: "seance/:id",
          name: "seance",
          component: Seance,
          meta : {
            requiresAuth: true,
            permission: true
          }
        },
        {
          path: "live_seance/:id",
          name: "liveSeance",
          component: LiveSeance,
          meta : {
            requiresAuth: true,
            permission: true
          }
        },
      ]
    },
    {
      path: '/login',
      component: () => import('~/pages/Login.vue'),
      name: 'login'
    },
    {
      path: '/register',
      component: () => import('~/pages/Register.vue'),
      name: 'register'
    },
    {
      path: '/request-reset-password',
      component: () => import('~/pages/RequestResetPassword.vue'),
      name: 'request-reset-password'
    },
    {
      path: '/request-reset-password-confirm',
      component: () => import('~/pages/RequestResetPasswordConfirm.vue'),
      name: 'request-reset-password-confirm',
      props: true
    },
    {
      path: '/reset-password/:id([0-9A-Za-z_\-]+)/:token([0-9A-Za-z]{1,13}-[0-9A-Za-z]{1,32})',
      component: () => import('~/pages/ResetPassword.vue'),
      name: 'reset-password'
    },
    {
      path: "/:idSeance(\\d+)", 
      component: Visu,
      name: "visu"
    },
    {
      path: "/mobile/:idSeance(\\d+)", 
      component: mobileDrinksLayout,
      children: [
        {
          path: "", 
          component: mobileDrinksList,
          name: "mobileDrinksList"
        },
        {
          path: ":idDrink(\\d+)", 
          component: mobileDrinksDetail,
          name: "mobileDrinksDetail"
        }
      ]
    },
    {
      path: "/", 
      component: Welcome,
      name: "welcome"
    },
    {
      // will match everything
      path: '*',
      component: () => import('~/pages/Page404.vue'),
      name: 'Page404'
    },
    {
      path: "/backoffice-connection", 
      component: () => import("./pages/IframeBackofficeConnection.vue"),
      name: "backoffice-connection"
    },
  ],
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const user = store.state.user;
  console.log(to);
  console.log(user);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log("requiresAuth");
    if (user.isAuthenticated) {
      console.log("isAuthenticated");
      if (to.matched.some(record => record.meta.permission)) {
        if (user.user.isAdmin) {
          next();
        } else {
          next("/dashboard")
        }
      } else {
        next()
      }
    } else {
      next('login')
    }
  } else {
    next();
  }
  if(!!user.accessToken){
    setJWT(user.accessToken);
  }
})

export default router;
